import { Component, OnInit } from '@angular/core';
import { DrawerService } from 'src/app/core/services/helper/drawer.service';
import { AdminDataService } from 'src/app/core/services/data/data.service';

@Component({
  selector: 'app-admin-dashboard',
  template: `
<div class="container">
    <!-- Modified top row with equal height enforcement -->
    <div fxLayout="row" 
         fxLayoutAlign="start stretch" 
         fxLayout.lt-md="column"
         fxLayoutGap="16px"
         class="equal-height-row">
      
      <!-- User Management -->
      <div fxFlex="calc(50% - 8px)"
           fxFlex.lt-md="100%"
           class="card-container">
        <div *ngxPermissionsOnly="['groups:*']" 
             class="card equal-height-card">
         <app-user-management></app-user-management>
        </div>
      </div>
      
      <!-- License Management -->
      <div fxFlex="calc(50% - 8px)"
           fxFlex.lt-md="100%"
           class="card-container">
        <div *ngxPermissionsOnly="['groups:*']" 
             class="card equal-height-card">
           <app-licence-management></app-licence-management>
        </div>
      </div>
    </div>
    
    <!-- Configuration (full width) -->
    <div fxLayout="row" fxLayoutAlign="center start">
      <div class="card-container full-width" fxFlex.lt-md="100%">
        <div *ngxPermissionsOnly="['configuration:*']" class="card">
           <app-configuration></app-configuration>
        </div>
      </div>
    </div>
    
    <!-- Monitoring (full width) -->
    <div fxLayout="row" fxLayoutAlign="center start">
      <div class="card-container full-width" fxFlex.lt-md="100%">
        <div *ngxPermissionsOnly="['metrics:*', 'metrics:read']" class="card">
          <app-monitoring></app-monitoring>
        </div>
      </div>
    </div>
  </div>
  `,
  styleUrls: ['./admin-dashboard.container.scss']
})
export class AdminDashboardComponent implements OnInit {
  constructor(
    private dataService: AdminDataService,
    public drawerService: DrawerService
  ) {}

  ngOnInit(): void {
    console.warn('Initializing admin Console Data');
    this.dataService.initialize();
  }
}